<div class="forms">
  <ng-container [formGroup]="form">
    <div nz-col nzXs="24" nzMd="24">
      <div
        class="nz-block-input"
					[ngClass]="{
						error:
							form.controls['jobCategoryId'].status === 'INVALID' &&
							form.controls['jobCategoryId'].touched
					}"
        >
        <label>Industry</label>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select industry"
          formControlName="jobCategoryId"
          >
          @for (data of jobCategories; track data) {
            <nz-option [nzLabel]="data.value"
              [nzValue]="data.id"
             />
          }
        </nz-select>
      </div>
    </div>
    <div class="row" nz-row nzGutter="16">
      <div nz-col nzXs="24" nzMd="12">
        <div
          class="nz-block-input"
						[ngClass]="{
							error:
								form.controls['roleId'].status === 'INVALID' &&
								form.controls['roleId'].touched
						}"
          >
          <label>Role</label>
          <nz-select
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select role"
            formControlName="roleId"
            >
            @for (e of roles; track e) {
              <nz-option [nzLabel]="e.jobRoleName"
                [nzValue]="e.roleId"
               />
            }
          </nz-select>
        </div>
      </div>

      <div nz-col nzXs="24" nzMd="12">
        <div
          class="nz-block-input"
						[ngClass]="{
							error:
								form.controls['levelId'].status === 'INVALID' &&
								form.controls['levelId'].touched
						}"
          >
          <label>Proficiency level</label>
          <nz-select
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select level"
            formControlName="levelId"
            >
            @for (e of proficiencyLevels; track e) {
              <nz-option [nzLabel]="e.levelName"
                [nzValue]="e.levelId"
               />
            }
          </nz-select>
        </div>
      </div>
    </div>
  </ng-container>
</div>